import {useParams} from 'react-router-dom'

import {toInt} from '../common/helpers'
import {PathParamKey} from '../declarations'

export const useMaterialId = (): number | undefined => {
  return toInt(useParams<Pick<Record<PathParamKey, string>, 'materialId'>>().materialId)
}
